import { Pipe, PipeTransform } from '@angular/core';
import type { TemplateRef } from '@angular/core';
import { TemplateProjectionMap } from '../../models/report.model';

@Pipe({
  name: 'selectTemplateOutlet',
  standalone: false,
})
export class SelectTemplateOutletPipe implements PipeTransform {
  transform(templateProjectionMap: TemplateProjectionMap, key: string): TemplateRef<any> {
    return templateProjectionMap ? templateProjectionMap[key] : null;
  }
}
